module.exports = __webpack_public_path__ + "static/media/smoking-ban.31095ef7.svg";